/**
 * Helper function to handle axios requests
 */
import store from "@/store";
import axios from "axios";

// let cancelSource = axios.CancelToken.source();
let controller = new AbortController();

export default () => {
  const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    // timeout: 50000,
    headers: {
      Accept: "*/*",
      Authorization: `Bearer ${store.state.auth.token}`,
      //   locale: "en",
    },
  });

  /** Axios Interceptors */
  instance.interceptors.request.use(
    (config) => {
      // config.cancelToken = cancelSource.token ? cancelSource.token : "";
      // console.log("req");
      config.signal = controller.signal;

      let cancelSource = axios.CancelToken.source();
      config.cancelToken = cancelSource.token;
      // Add to vuex to make cancellation available from anywhere
      store.commit("ADD_CANCEL_TOKEN", cancelSource);
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => {
      if (response.data.error === 1 && response.data.statusCode === 401) {
        // cancelSource.cancel("Request canceled");
        controller.abort();
        store.dispatch("CANCEL_PENDING_REQUESTS");
        store.dispatch("logout");
      }
      return response;
    },
    (error) => {
      if (error.toJSON().message === "Network Error") {
        store.dispatch("networkError");
      }
      // console.log(error);
      // cancelSource = axios.CancelToken.source();
      controller = new AbortController();
      return Promise.reject(error);
    }
  );
  /** End of Interceptors */
  return instance;
};
